import moment from "moment";

export const sortDate = (datesArray) => {
  return datesArray
    .map((el) => moment(el).valueOf())
    .sort((a, b) => b - a)
    .map((el) => moment(el).format("DD/MM/YYYY"));
};
